import * as React from "react";
import { cn } from "../../../lib/utils";

/**
 * A citation's number as a small filled badge, drawn the same inline in the reply and
 * on its chip underneath, so the eye can pair "2" in the prose with "2" in the list.
 *
 * It was plain accent-coloured "[2]" text a size down, which read as punctuation: at
 * pane width, in a paragraph of prose, nothing said it could be clicked. A filled
 * shape does, and filling it on hover says it again.
 */
const CitationBadge: React.FC<{
  n: number;
  /** Drawn instead of the number: the "+N" of a folded run (utils/citationRuns). */
  label?: string;
  interactive?: boolean;
}> = ({ n, label, interactive }) => (
  <span
    className={cn(
      "inline-block h-4 min-w-4 rounded-full bg-primary-tint px-1 text-center align-[1px] text-[10.5px] leading-4 font-bold text-primary",
      interactive &&
        "cursor-pointer transition-colors duration-[120ms] hover:bg-primary hover:text-primary-foreground"
    )}
  >
    {label ?? n}
  </span>
);

export default CitationBadge;
